import React from "react";
import { Stack } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { es } from "date-fns/locale";
import { format, isValid, parseISO, subDays } from "date-fns";

// «YYYY-MM-DD» ↔ Date: los reportes van por días completos, sin hora.
export const isoToDate = (value) => {
    if (!value) return null;
    const date = parseISO(value);
    return isValid(date) ? date : null;
};

export const dateToIso = (date) => (date && isValid(date) ? format(date, "yyyy-MM-dd") : null);

export const todayIso = () => format(new Date(), "yyyy-MM-dd");

export const yesterdayIso = () => format(subDays(new Date(), 1), "yyyy-MM-dd");

// Desde y Hasta de un reporte, en español (dd-mm-aaaa). Mientras se escribe, una fecha incompleta no borra la anterior.
const ReportDateRange = ({ from, to, onChange, minDate = null, maxDate = todayIso(), size = "medium", disabled = false }) => {
    const textField = { size, fullWidth: true };
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
            <Stack direction="row" spacing={1} sx={{ width: "100%" }}>
                <DatePicker
                    label="Desde" format="dd-MM-yyyy" value={isoToDate(from)} disabled={disabled}
                    minDate={isoToDate(minDate) || undefined} maxDate={isoToDate(to) || isoToDate(maxDate) || undefined}
                    onChange={(date) => { const iso = dateToIso(date); if (iso) onChange({ from: iso }); }}
                    slotProps={{ textField }}
                />
                <DatePicker
                    label="Hasta" format="dd-MM-yyyy" value={isoToDate(to)} disabled={disabled}
                    minDate={isoToDate(from) || isoToDate(minDate) || undefined} maxDate={isoToDate(maxDate) || undefined}
                    onChange={(date) => { const iso = dateToIso(date); if (iso) onChange({ to: iso }); }}
                    slotProps={{ textField }}
                />
            </Stack>
        </LocalizationProvider>
    );
};

export default ReportDateRange;
